import React from 'react';
import PropTypes from 'prop-types';
import HOCFilter from 'web-common/bizzabo-components/components/BZHOCFilter';
import TagsFilter from './TagsFilter';
import NestedTags from './NestedTagsFilter';
import TimeFilter from './TimeFilter';

const TagsFilterProps = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.shape(
        {
            filterId: PropTypes.number,
            id: PropTypes.number,
            name: PropTypes.string,
            categoryName: PropTypes.string.isRequired,
            isSelected: PropTypes.bool
        }
    ))
});

const NestedTagsFilterProps = PropTypes.shape({
    ...TagsFilterProps,
    tags: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            name: PropTypes.string,
            categoryName: PropTypes.string.isRequired,
            eventId: PropTypes.number,
            isSelected: PropTypes.bool,
            subTags: PropTypes.arrayOf(PropTypes.shape(
                {
                    id: PropTypes.number,
                    parentId: PropTypes.number,
                    name: PropTypes.string,
                    categoryName: PropTypes.string.isRequired
                }
            ))
        }
    ))
});

const FilterProps = {
    type: PropTypes.oneOf(['TAGS', 'NESTED_TAGS', 'TIME']),
    selectedCategoryId: PropTypes.number,
    filters: PropTypes.arrayOf(PropTypes.oneOfType([TagsFilterProps, NestedTagsFilterProps]))
};

const Props = {
    filters: PropTypes.arrayOf(PropTypes.shape(FilterProps)),
    handlers: PropTypes.object,
    label: PropTypes.string,
    header: PropTypes.string,
    counter: PropTypes.number,
    filterUI: PropTypes.object.isRequired
};


const SessionsFilter = (props) => {
    const {
        filters: filtersProps,
        handlers: {
            selectFilterCategory,
            toggleFilter,
            toggleTag,
            clearCategoryTags,
            clearLocationsTags,
            updateTime,
            selectTime,
            clearTime
        },
        filterUI: { selectedCategoryId },
        color
    } = props;

    const filters = filtersProps.map(filter => {
        switch (filter.type) {
        case 'NESTED_TAGS':
            return {
                props: {
                    ...filter,
                    toggleTag,
                    selectFilterCategory,
                    selectedCategoryId,
                    clearCategoryTags: clearLocationsTags,
                    color
                },
                renderer: NestedTags
            };
        case 'TIME':
            return {
                props: {
                    ...filter,
                    selectFilterCategory,
                    selectedCategoryId,
                    updateTime,
                    selectTime,
                    clearTime,
                    color
                },
                renderer: TimeFilter
            };
        default:
            return {
                props: {
                    ...filter,
                    toggleTag,
                    selectFilterCategory,
                    selectedCategoryId,
                    clearCategoryTags,
                    color
                },
                renderer: TagsFilter
            };
        }

    });
    const filterProps = { ...props, toggleFilter, filters, bsId: 'sessions-filter' };
    return (
        <HOCFilter {...filterProps}/>
    );
};
SessionsFilter.propTypes = Props;
export default SessionsFilter;
